<template>
  <div class="inner_card">
    <p class="card_title">
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      {{ parcours.nom }}
    </p>

    <div class="container_block_extra_infos">
      <div class="block_extra_infos" v-if="parcours.metadata.date_course">
        <div>
          <b-icon icon="flag-fill"></b-icon>
        </div>
        <div>
          <p>
            Départ <span>{{ parcours.metadata.date_course }}</span> <span>{{ parcours.metadata.heure_depart }}</span>
          </p>
        </div>
      </div>
      <div class="block_extra_infos" v-if="parcours.metadata.denivele_affiche">
        <div>
          <v-icon name="mountain" />
        </div>
        <div>
          <p>
            <span>{{ parcours.metadata.denivele_affiche }}</span>
          </p>
        </div>
      </div>
      <div class="block_extra_infos block_green" v-if="$store.state.module.inscription_ouverte && !parcours.metadata.complet && $store.state.module.base != 'CVD22'">
        <div>
          <b-icon icon="file-earmark-check-fill"></b-icon>
        </div>
        <div>{{ $t("tab_courses.inscriptions_ouvertes") }}</div>
      </div>
      <div class="block_extra_infos block_red" v-else-if="$store.state.module.base != 'CVD22'">
        <div>
          <b-icon icon="file-earmark-x-fill"></b-icon>
        </div>
        <div>
          <span v-if="!$store.state.module.inscription_pas_encore_ouverte">{{ $t("tab_courses.inscriptions_closes") }} </span>
          <span v-if="$store.state.module.inscription_pas_encore_ouverte">{{ $t("tab_courses.ouverture_inscriptions") }} {{ $store.state.module.readable_ouverture_date }}</span>
        </div>
      </div>
    </div>

    <div v-if="parcours.is_live">
      <router-link :to="{ name: 'Parcours', params: { course: parcours.nom } }">
        <b-button class="inline-btn with_icon"><b-icon icon="map" aria-hidden="true"></b-icon> {{ $t("tab_courses.voir_trace") }}</b-button>
      </router-link>
      <router-link v-if="$store.state.showParticipantsTab" :to="{ path: '/' + this.$store.state.module.base + '/inscriptions' }">
        <b-button class="inline-btn with_icon"><b-icon icon="person-lines-fill" aria-hidden="true"></b-icon> {{ $t("tab_courses.list_participants") }}</b-button>
      </router-link>
      <router-link v-else :to="{ name: 'Live', params: { course: parcours.nom, tab: 'participants' } }">
        <b-button class="inline-btn with_icon"><b-icon icon="person-lines-fill" aria-hidden="true"></b-icon> {{ $t("tab_courses.list_participants") }}</b-button>
      </router-link>
      <router-link :to="{ name: 'Live_Passages', params: { course: parcours.nom, tab: 'passages' } }">
        <b-button class="inline-btn with_icon"><b-icon icon="geo" aria-hidden="true"></b-icon> {{ $t("passages") }}</b-button>
      </router-link>
      <router-link :to="{ name: 'Live_Podiums', params: { course: parcours.nom, tab: 'podiums' } }"
        ><b-button class="inline-btn with_icon"><b-icon icon="trophy" aria-hidden="true"></b-icon> {{ $t("podiums") }}</b-button></router-link
      >
      <router-link :to="{ name: 'Resultats', params: { course: parcours.nom } }"
        ><b-button class="inline-btn with_icon"><b-icon icon="list-ol" aria-hidden="true"></b-icon> {{ $t("resultats") }}</b-button></router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["parcours"],
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="sass" scoped>
</style>